import React, { useState, useEffect } from 'react';
import store, { borrowerActions } from '@apply/adminStore';
import { BorrowerApi } from '@apply/api';
import { applicationInsights } from '../../../ApplicationInsights';
import { onActionsCellRender } from '../BorrowerFunctions';
import { LinkType } from '../BorrowerConstants';
import { BfiDataGrid, Column } from '@apply/ui';

export const PrincipalEntityLinks = ({ principalId, parentId, gridStore, excludeEntityId = 0 }) => {
    const { dispatch } = store;
    const borrowerApi = new BorrowerApi.BorrowerApi(applicationInsights);
    const [dataStore, set_dataStore] = useState(gridStore?.store);

    const styles = {
        buttonContainer: {
            textAlign: 'right',
            borderTop: '2px solid silver',
            padding: '10px 10px',
        },
        buttonContainer2: {
            textAlign: 'right',
            padding: '5px',
        },
        sectionHeader: { margin: '10px 0' },
        formColumn: { paddingBottom: '5px', paddingRight: '5px' },
    };

    const removeExcludedEntity = (lnks) => {
        if (excludeEntityId) {
            return lnks.filter((o) => {
                return o.entityId !== excludeEntityId;
            });
        } else {
            return lnks;
        }
    };

    const dataFunction = async (criteria) => {
        const response = await borrowerApi.getPrincipalEntityLinks(principalId);
        if (response.statusCode !== 200) {
            return;
        }

        const links = removeExcludedEntity(response.result);
        return {
            statusCode: 200,
            result: {
                data: links,
                totalCount: links.length,
                summary: null,
            },
        };
    };

    useEffect(() => {
        if (gridStore) {
            gridStore.setOnLoad('entityId', dataFunction, null);
            set_dataStore(gridStore.store);
        }
    }, [gridStore]);

    const onPercentCellRender = (e) => {
        if (!e.value) {
            return null;
        }
        return e.value.toFixed(2) + '%';
    };

    const onAddLink = (e) => {
        e.preventDefault();
        e.stopPropagation();
        dispatch(
            borrowerActions.setEditBorrowerEntityToPrincipalLinkModal({
                editBorrowerEntityToPrincipalLinkModal: {
                    isOpen: true,
                    entityId: 0,
                    principalId,
                    linkType: LinkType.Entity,
                },
            })
        );
    };

    const onCellDblClick = (e) => {
        dispatch(
            borrowerActions.setEditBorrowerEntityToPrincipalLinkModal({
                editBorrowerEntityToPrincipalLinkModal: {
                    isOpen: true,
                    entityId: e.data.entityId,
                    principalId,
                    mode: LinkType.Entity,
                },
            })
        );
    };

    const onBooleanRender = (e) => {
        return e.value ? 'Yes' : 'No';
    };

    if (!principalId) {
        return null;
    }

    return (
        <div>
            <div className='row'>
                <div
                    className='columns small-12 large-12'
                    style={styles.formColumn}
                >
                    <div style={styles.buttonContainer2}>
                        <button
                            type='button'
                            className='button hollow'
                            onClick={onAddLink}
                            title='Add a new entity to this contact'
                            style={{ marginBottom: '2px' }}
                            disabled={principalId === 0}
                        >
                            Link to Entity
                        </button>
                    </div>
                    <BfiDataGrid
                        dataSource={dataStore}
                        showBorders={true}
                        showRowLines={false}
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        allowColumnReordering={false}
                        allowColumnResizing={true}
                        cellHintEnabled={true}
                        onCellDblClick={onCellDblClick}
                        keyExpr='entityId'
                        applicationInsights={applicationInsights}
                    >
                        <Column
                            dataField='name'
                            caption='Entity Name'
                        />
                        <Column
                            dataField='city'
                            caption='City'
                            width={120}
                        />
                        <Column
                            dataField='state'
                            caption='State'
                            width={70}
                        />
                        <Column
                            dataField='title'
                            caption='Title at Entity'
                            width={150}
                        />
                        <Column
                            dataField='isOfficer'
                            caption='Officer'
                            width={100}
                            cellRender={onBooleanRender}
                        />
                        <Column
                            dataField='percentOwnership'
                            caption='% Owned'
                            width={80}
                            cellRender={onPercentCellRender}
                            alignment='left'
                        />
                        <Column
                            type='actions'
                            alignment='center'
                            cellRender={(e) => onActionsCellRender(e, parentId)}
                            width={50}
                            allowReordering={false}
                            allowSorting={false}
                            allowResizing={false}
                            fixed={true}
                            fixedPosition={'right'}
                        />
                    </BfiDataGrid>
                </div>
            </div>
        </div>
    );
};
